// removed by extract-text-webpack-plugin
module.exports = {"Comments":"Comments__Comments__4WOT6","marquee":"Comments__marquee__2f4Rd","C1":"Comments__C1__2Sm9v","C2":"Comments__C2__2Ks-7","C3":"Comments__C3__2PThX","C4":"Comments__C4__3ZVmP","C5":"Comments__C5__1Qn5X","C6":"Comments__C6__18bnk","C7":"Comments__C7__1AihH","C8":"Comments__C8__XRtnT","C9":"Comments__C9__2Ewk9","C10":"Comments__C10__3nw5i","C11":"Comments__C11__2dBEm","C12":"Comments__C12__1TJ2C","C13":"Comments__C13__cNAnA","C15":"Comments__C15__1Gnc6","C16":"Comments__C16__73drC","C17":"Comments__C17__1mLVB","C18":"Comments__C18__3Mqk2","C19":"Comments__C19__hActk","C20":"Comments__C20__1pyC9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comments/Comments.css
// module id = 401
// module chunks = 0